import React from 'react'
import { IDocumentReportParams } from 'types'

interface Props {

}

interface Hook {
    params: IDocumentReportParams
    handleChangeParams: (key: string, value: any) => void
}

const useReportParams = (props?: Props): Hook => {
    const [params, setParams] = React.useState<IDocumentReportParams>({
        simple: {
            conditions: [],
            documentEnd: new Date(),
            documentStart: new Date(),
            types: []
        },
        state: {  
            conditions: [],
            documentEnd: new Date(),
            documentStart: new Date(), }
    })
    const handleChangeParams = (key: string, value: any) => {
        setParams(current => ({
            ...current,
            [key]: value
        }))
    }
    return {
        params,
        handleChangeParams
    }
}

export default useReportParams
